import axios from "axios";
import { attachAuthInterceptor } from "./authInterceptor";

const jobsClient = axios.create({
  baseURL: import.meta.env.VITE_JOBS_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(jobsClient);

export default jobsClient;
